export const CREATE_NEW_OFFER_TOOLTIP = 'Create a new offer to change this value.';

export const isFilled = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return typeof value === 'string' ? value.trim() !== '' : value !== null && value !== undefined;
};
